import React, { useEffect, useState } from "react";
import styled, { css } from "styled-components";
import COLORS from "../../../assets/Colors";
import theme from "../../../assets/theme";
import _ from "lodash";
import { Tooltip } from "@material-ui/core";

const Index = ({
  items = [],
  selectedIndex = 1,
  isMediation = false,
  resolutionKind,
  status,
  currentStateKey,
  setStatusModal,
  viewOnly,
  caseObj,
  onClose = () => {},
}) => {
  const [caseCycle, setCaseCycle] = useState([]);

  useEffect(() => {
    const duplicateList = [];
    const labelMap = {
      "Mediation/Arbitration Initiated": `${_.capitalize(resolutionKind)} Initiated`,
      "Mediation/Arbitration In Progress": `${_.capitalize(resolutionKind)} In Progress`,
      "Mediation/Arbitration Completed": `${_.capitalize(resolutionKind)} Completed`,
    };

    const cycleList = items
      .filter((item) => {
        if (duplicateList.includes(item.index)) return false;
        duplicateList.push(item.index);
        return true;
      })
      .map((item) => ({
        ...item,
        label: labelMap[item.label] || item.label,
      }));

    setCaseCycle(cycleList);
  }, [items, isMediation, resolutionKind, currentStateKey]);

  const matchedIndex = caseCycle.findIndex(
    (item) => item.key === caseObj?.status,
  );

  const activeIndex = matchedIndex !== -1 ? matchedIndex + 1 : selectedIndex;

  return (
    <LifecycleWrapper>
      {caseCycle.map((item, index) => (
        <LifecycleBorder
          isFirst={index === 0}
          selected={activeIndex === index}
          key={index}
        >
          <Lifecycle isFirst={index === 0} selected={activeIndex > index}>
            <Lifecycle isFirst={index === 0} selected={activeIndex > index}>
              {activeIndex === index + 1 && resolutionKind !== "negotiation" ? (
                <Tooltip title={status} placement="right">
                  <TextContainer
                    onClick={() =>
                      resolutionKind === "arbitration" &&
                      viewOnly !== true &&
                      (onClose(), setStatusModal(true))
                    }
                  >
                    {item.label}
                  </TextContainer>
                </Tooltip>
              ) : (
                <TextContainer>{item.label}</TextContainer>
              )}
            </Lifecycle>
          </Lifecycle>
        </LifecycleBorder>
      ))}
    </LifecycleWrapper>
  );
};

export default Index;

const LifecycleWrapper = styled.div`
  margin: 5px 0;
  display: flex;
`;
const LifecycleBorder = styled.div`
  width: 160px;
  height: 60px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 4px;
  margin-left: -16px;
  clip-path: ${({ isFirst }) =>
    isFirst
      ? "polygon(0 0, 85% 0, 100% 50%, 85% 100%, 0% 100%)"
      : "polygon(85% 0, 100% 50%, 85% 100%, 0% 100%, 15% 50%, 0% 0%)"};
  ${({ selected }) =>
    !selected &&
    css`
      background: ${COLORS.BORDER_GREY};
    `}
  ${({ isFirst }) =>
    isFirst &&
    css`
      margin-left: 0px;
    `}
`;

const Lifecycle = styled.div`
  width: 158px;
  height: 59px;
  border-radius: 4px;
  background-color: ${COLORS.PRIMARY_WHITE};
  clip-path: ${({ isFirst }) =>
    isFirst
      ? "polygon(0 0, 85% 0, 100% 50%, 85% 100%, 0% 100%)"
      : "polygon(85% 0, 100% 50%, 85% 100%, 0% 100%, 15% 50%, 0% 0%)"};
  display: flex;
  justify-content: center;
  align-items: center;
  ${({ selected }) =>
    selected &&
    css`
      margin-left: unset;
      background-color: ${COLORS.COLOR_DARK};
      & div {
        color: ${COLORS.PRIMARY_WHITE};
      }
    `}

  &:last-child {
    & div {
      text-align: center;
    }
  }
`;
const TextContainer = styled.div`
  width: 90px;
  text-align: left;
  text-transform: capitalize;
  font-family: ${theme.fonts.primaryFontBold};
  font-size: 10px;
  line-height: 1.6;
  color: ${COLORS.INPUT_LABEL};
`;
